import React from 'react'
import CalendarLib from 'react-calendar'

import {
	Container,
	PrevMonthIcon,
	NextMonthIcon,
} from './Calendar.styles'

interface CalendarProps {
	selectedDate?: Date,
	onSelectedDate: (date: Date | Date[]) => any
	showRedesignedVersion?: boolean,
}

export default function Calendar(
	{
		selectedDate,
		onSelectedDate,
		showRedesignedVersion = false,
	}: CalendarProps,
) {

	return (
		<Container showRedesignedVersion={showRedesignedVersion}>
			<CalendarLib
				onChange={onSelectedDate}
				value={selectedDate}

				calendarType={'US'}
				locale={'US'}
				navigationLabel={({ label }) => {
					return <p className={'navigation-label'}>{label}</p>
				}}
				prevLabel={<PrevMonthIcon />}
				nextLabel={<NextMonthIcon />}
				tileClassName={({ date }) => {
					return 'tile'
				}}
				prev2Label={null}
				next2Label={null}
			/>
		</Container>
	)
}
